<i18n>
  {
    "en": {
      "message": {
        "hello": "hello world"
      }
    },
    "zh-tw": {
      "permissions": {
        "GET_STORE_INFO": "讀取餐廳基本設定",
        "UPDATE_STORE_INFO": "更新餐廳基本設定",
        "GET_STATISTICS": "讀取統計資料",
        "GET_ORDER": "讀取餐點",
        "UPDATE_ORDER_PROCESS_STATUS": "更新餐點處理狀態",
        "UPDATE_ORDER_RECEIPT_PRINTED_STATUS": "重新列印",
        "UPDATE_ORDER_PAYMENT_STATUS": "結帳",
        "REFUND_ORDER": "訂單退款",
        "DELETE_ORDER": "刪除訂單",
        "GET_STORE_MENU_DRAFT": "讀取菜單草稿",
        "CREATE_STORE_MENU_DRAFT": "新增菜單草稿",
        "UPDATE_STORE_MENU_DRAFT": "修改菜單草稿",
        "DELETE_STORE_MENU_DRAFT": "刪除菜單草稿",
        "RELEASE_STORE_MENU": "發佈菜單",
        "CASHIER_BASIC": "收銀機管理",
        "GET_USER_PERMISSION": "讀取使用者權限",
        "UPDATE_USER_PERMISSION": "修改使用者權限 (ex. 新增員工、移除員工)"
      }
    }
  }
</i18n>

<template>
  <f7-page>
    <f7-navbar title="員工權限編輯" back-link="back">
      <f7-nav-right>
        <f7-link @click="confirmUpload">
          <font-awesome-icon :icon="['far', 'save']" />
        </f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div v-if="isPermissionsDirty" class="warning">請按上傳完成變更</div>

    <f7-list media-list>
      <f7-list-item :title="currentEmployee.email" :subtitle="fullStoreName">
        <img slot="media" :src="currentEmployee.photoURL" style="width: 48px; border-radius: 50%;"/>
        <f7-button slot="content" fill raised style="background: red; width: 80px; margin-right: 20px;" @click="deleteEmployee">刪除</f7-button>
      </f7-list-item>
      <f7-list-item
        v-for="(permission, index) in allPermissions"
        :key="`employee-permissions-${index}`"
        checkbox
        :title="$t(`permissions.${permission}`)"
        :checked="currentEmployeePermissions[permission]"
        @change="e => setPermission(permission, e.target.checked)" />
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { systemPermissions, userPermissionSettingList } from '@/common/constants/permissions'
import Vue from 'vue'
import * as R from 'ramda'
import { storeClient } from '@/service/apiClients'

export default {
  dependencies: ['permissionType'],
  data () {
    return {
      currentEmployeePermissions: {},
      originalEmployeePermissions: {}
    }
  },
  props: {
    uid: String
  },
  created () {
    this.allPermissions.forEach(p => {
      const value = !!(systemPermissions[p] & this.currentEmployee.permissions)
      Vue.set(this.currentEmployeePermissions, p, value)
      Vue.set(this.originalEmployeePermissions, p, value)
    })
  },
  computed: {
    ...mapState('managerModule', ['employees']),
    ...mapGetters(['storeId', 'fullStoreName']),
    currentEmployee () {
      return this.employees.find(e => e.uid === this.uid)
    },
    allPermissions () {
      return userPermissionSettingList.filter(item => item !== this.permissionType.createStore)
    },
    isPermissionsDirty () {
      return !R.equals(this.currentEmployeePermissions, this.originalEmployeePermissions)
    }
  },
  methods: {
    ...mapActions('managerModule', ['getAllEmployees']),
    setPermission (permission, v) {
      Vue.set(this.currentEmployeePermissions, permission, v)
    },
    confirmUpload () {
      const addPermissions = []
      const removePermissions = []
      Object.keys(this.currentEmployeePermissions).forEach(k => {
        if (this.currentEmployeePermissions[k] !== this.originalEmployeePermissions[k]) {
          if (this.currentEmployeePermissions[k]) {
            addPermissions.push(this.$t(`permissions.${k}`))
          } else {
            removePermissions.push(this.$t(`permissions.${k}`))
          }
        }
      })
      const results =
        '新權限將在一小時內或下次使用者登入後生效<br>' +
        addPermissions.reduce((r, p) => `${r}[+] ${p}<br>`, '') +
        removePermissions.reduce((r, p) => `${r}[-] ${p}<br>`, '')

      this.$f7.dialog.confirm(results, '確認修改', async () => {
        this.$f7.dialog.preloader('更新中')
        try {
          await storeClient.put(`/stores/${this.storeId}/employee/permissions`, {
            permissions: [{ uid: this.uid, permissions: this.currentEmployeePermissions }]
          })
        } catch (e) {
          if (process.env.NODE_ENV === 'development') {
            console.log(e)
          }
        }
        this.$utils.nextFrame(() => this.$f7.dialog.close())
        this.getAllEmployees()
        this.$f7router.back()
      })
    },
    deleteEmployee () {
      this.$f7.dialog.confirm(this.currentEmployee.email, '確認刪除', async () => {
        this.$f7.dialog.preloader('刪除中')
        try {
          await storeClient.delete(`/stores/${this.storeId}/deleteEmployee/${this.uid}`)
          this.$f7router.back()
        } catch (e) {
          if (process.env.NODE_ENV === 'development') {
            console.log(e)
          }
        }
        this.$utils.nextFrame(() => this.$f7.dialog.close())
        this.getAllEmployees()
        this.$f7router.back()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.warning {
  color: #856404;
  background-color: #FFF3CD;
  border: solid 1px #FFEEBA;
  border-radius: 5px;
  width: 90%;
  margin: 20px auto;
  padding: 10px 20px;
  box-shadow: 2px 2px 2px #EEEEEE;
  box-sizing: border-box;
}
</style>
